<template>
  <Modal v-model="model" sticky reset-drag-position :title="sorttitle" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="insert_edit_dept">
      <div class="pop_top">
        <div>
          <div class="dept_edit_input">
            <div class="font_style_set" style="text-align:right"><span style="color: red;margin-left: 5px">*</span>快捷词:</div>
            <el-Input v-model="replyWord" :maxlength="50"/>
          </div>
          <br/>
          <div class="dept_edit_input">
            <div class="font_style_set" style="text-align:right"><span style="color: red;margin-left: 5px">*</span>话术内容:</div>
            <el-Input v-model="replyContent" :maxlength="90"/>
          </div>
          <!-- <el-form :label-position="labelPosition" label-width="80px">
            <el-form-item label="话术内容">
              <el-input v-model="replyContent"></el-input>
            </el-form-item>
            <el-form-item label="快捷词">
              <el-input type="textarea" v-model="replyWord"></el-input>
            </el-form-item>
          </el-form> -->
        </div>
      </div>
      <div class="btn_template">
        <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
        <Button type="primary" class="submit_btn" @click="savecon()">保存</Button>
      </div>
  </Modal>
</template>

<script>
    export default {
        name: "addspcraPop",
        props: {
          showaddspcra:Boolean,
          sortId:String,
          sorttitle:String,

          selectedTreeId:String,
          selectlib:String,
          reId:String,
        },
        data(){
          return{
            model:false,

            replyContent:'',
            replyWord:'',

            agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
            newSortName:'',
            labelPosition: 'right',

          }
        },
        methods:{
          cancel:function(){
            this.$emit("closeaddspcra",false);
          },
         searchcontent:function(){//查询单条内容
              let param={
                id:this.sortId,
                replyType:this.selectlib,
                meanType:'1'
              };
              let that=this;
              this.$http.post("chatReply/doSelectOneById.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
                let list=res.data.obj.list;
                if(list.length>0){
                  that.replyContent=list[0].replyContent;
                  that.replyWord=list[0].replyWord;
                }
              });
          },

          savecon:function(){
              if(!this.replyContent){
                this.$Modal.info({
                  title:'提示',
                  content:"话术内容不能为空"
                });
                return false;
              }
              if(!this.replyWord){
                this.$Modal.info({
                  title:'提示',
                  content:"快捷词不能为空"
                });
                return false;
              }
              let param;
              if(this.sortId){
                param={
                    agentNumber:this.agentInfo.agentNumber,
                    id:this.sortId,
                    replyId:this.reId,
                    replyContent:this.replyContent,
                    replyWord:this.replyWord,
                    replyType:this.selectlib,
                    meanType:'1',
                    journalType:"系统管理=>会话配置=>快捷回复=>编辑话术",
                    menuId:"3_12-4-5"
                };
              }else{
                param={
                    agentNumber:this.agentInfo.agentNumber,
                    id:this.sortId,
                    replyId:this.selectedTreeId,
                    replyContent:this.replyContent,
                    replyWord:this.replyWord,
                    replyType:this.selectlib,
                    meanType:'1',
                    journalType:"系统管理=>会话配置=>快捷回复=>添加话术",
                    menuId:"3_12-4-4"
                };
              }

              let that=this;
              this.$http.post("chatReply/doReplyRelationSave.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
                that.$Message.info("保存成功");
                that.$emit("closeaddspcra",true);
              });
          }
        },
        watch:{
          showaddspcra:function () {
            this.model=this.showaddspcra;
            this.newSortName="";

            this.replyContent="";
            this.replyWord="";
            if(this.sortId){
              this.searchcontent();
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/addspcraPop.vue